import { render, staticRenderFns } from "./IndicationsTabs.vue?vue&type=template&id=5d97094a&scoped=true&"
import script from "./IndicationsTabs.vue?vue&type=script&lang=js&"
export * from "./IndicationsTabs.vue?vue&type=script&lang=js&"
import style0 from "./IndicationsTabs.vue?vue&type=style&index=0&id=5d97094a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97094a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
